module.exports = __webpack_public_path__ + "static/screencapture-katesargent-2019-06-01-19_05_14 copy-7449dd0d4054e654139d87ba7add6043.png";